import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './components/lib/theme-change';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
   // <React.StrictMode> disabling strict mode as it is meant for stability testing only
   <ThemeProvider attribute="class">
      <App />
   </ThemeProvider>
   // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
